import React from 'react';

export const DragHandleIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="16"
		fill="none"
		data-testid="drag-icon-enabled"
	>
		<rect width="24" height="16" rx="4" />
		<g>
			<path d="M9 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM9 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z" />
		</g>
	</svg>
);
